const React = require('react');
const SharedConstants = require('../../../../shared/sharedConstants');
const SharedModels = require('../../../../shared/sharedModels');
const Hopscotch = require('hopscotch');
const MultiLineTextField = require('./commonControls.jsx.js').MultiLineTextField;
const HopscotchTours = require('./../hopscotchTours.js');
const Toastr = require('toastr');
const AjaxFunctions = require('./../ajaxFunctions.js');
const ReduxStore = require('./../redux/reduxStore.jsx.js');
const PropTypes = require('prop-types');
const LocalStorage = require('../localStorage.js');
const Utils = require('./../utils');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const toastAlert = require('./toastAlert');

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Select from 'react-select';

export default class EvidenceCreationPage extends React.Component{
   constructor(props){
      super(props);
      this.state= {
         shrinkCard: false,
      }
   }

   animateShrink(){
      this.setState({shrinkCard: true});
   }

   onCreate(idEvidenceCard){
      this.props.onCreate(idEvidenceCard);
   }

   onCreateBegin(){
      if(this.props.onCreateBegin){
         this.props.onCreateBegin();
      }
      this.animateShrink()
   }

   render(){
      return(
         <div className={'page-container evidence-creation-page'}>
            <EvidenceCreation
               {...this.props}
               onCreateBegin={() => this.onCreateBegin()}
               onCreate={idEvidenceCard => this.onCreate(idEvidenceCard)}
            />
         </div>
      )
   }
}

class EvidenceCreationBase extends React.Component{
   constructor(props) {
      super(props);
      let savedState = null;
      try {
         if (Utils.getParameterByName('isRevision', window.location.href)) {
            savedState = this.props.revisingCard
         } else {
            savedState = JSON.parse(LocalStorage.getItem('evidenceCreationState'));
         }
      } catch (e) {
         console.log('could not load saved evidence creation state');
      }
      if (savedState) {
         if (!savedState.citation) savedState.citation = '';
         if (!savedState.enteredText) savedState.enteredText = '';
         if (!savedState.sourceDate) savedState.sourceDate = '';
         if (!savedState.submitButtonText) savedState.submitButtonText = 'Submit';
         if (!savedState.portfolio) savedState.portfolio = '';
         this.state = savedState;
      } else {
         this.state = {
            id: '',
            enteredText: '',
            citation: '',
            tour: null,
            isWaitingOnSubmit: false,
            submitButtonText: 'Submit',
            startPressed: false,
            fieldErrors:{},
            evidenceFieldsRequired: true,
            portfolio: '',
         }
      }
   }

   componentDidUpdate() {
      if (Utils.getParameterByName('isRevision', window.location.href) && this.state.id !== this.props.revisingCard.id) {
         this.setState({
            id: this.props.revisingCard.id,
            enteredText: this.props.revisingCard.enteredText,
            citation: this.props.revisingCard.citation,
            sourceDate: this.props.revisingCard.sourceDate,
            tour: null,
         });
      }
   }

   cancel(){
      if(this.state.tour){
         Hopscotch.endTour(false);
      }
   }

   clearCardInput(){
      document.getElementById('cardCreationEvidenceCitation').value = '';
      document.getElementById('cardCreationEvidenceSynopsis').value = '';
      this.setState({
         id: '',
         enteredText: '',
         citation: '',
         portfolio: '',
         fieldErrors: {},
         startPressed: false,
         evidenceFieldsRequired: true,
      });

      let toSaveState = {...this.state, 'tour': null};
      LocalStorage.setItem('evidenceCreationState', JSON.stringify(toSaveState));
   }

   async componentDidMount() {
      let evidenceFieldSetting = await AjaxFunctions.getSetting('evidenceFieldsRequired');
      let evidenceFieldsRequired = (evidenceFieldSetting == true)
      let fieldErrors = {};
      if (evidenceFieldsRequired == true) {
         fieldErrors = { citation:false, url:false, year:false }
      } else {
         fieldErrors = { summary:false }
      }
      let tour = HopscotchTours.CreateEvidenceTour(
         () => Utils.updateCurrentUserData()
      );
      this.setState({ tour, evidenceFieldsRequired, fieldErrors });
   }

   reviseEvidence() {
      this.setState({ isWaitingOnSubmit: true, submitButtonText: 'Updating...' }, async () => {
         let cardObject = {
            title: this.state.enteredText,
            citation: this.state.citation,
            sourceDate: this.state.sourceDate,
            id: this.state.id,
         };

         await AjaxFunctions.reviseEvidenceCard(cardObject);
         this.setState({isWaitingOnSubmit: false, submitButtonText: 'Submit'});
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.success('Updated evidence.');
         AjaxFunctions.getUnapprovedCards().then((list) => {
            ReduxStore.store.dispatch(ReduxStore.CardFunctions.setUnapproved(list));
         });
         this.props.onCreate();
         Utils.updateCurrentUserData();
      });
   }

   createEvidenceCard() {
      if (this.getErrorFields()) {
         toastAlert.error("Error Creating: Please fix the highlighted issues.");
         this.setState({ startPressed: true });
         return;
      }

      if(this.props.externalRequirementsNotMet){
         toastAlert.error("Error Creating: Make sure all required fields are filled.");
         this.setState({ startPressed: true });
         return;
      }

      if (this.state.id) {
         this.reviseEvidence();
         return;
      }

      if (!window.globals.idUser) {
         Toastr.options.positionClass = 'toast-bottom-full-width';
         Toastr.error('Only Registered Users Can Create Evidence.');
         document.getElementById('btnNavBarSignIn').click();
         return;
      }

      this.props.onCreateBegin();
      this.setState({ isWaitingOnSubmit: true, submitButtonText: 'Creating...' }, () => {
         let card = new SharedModels.EvidenceCard({
            citation: this.state.citation,
            title: this.state.enteredText,
            topics: [], // topics placeholder
            tags: [],   // tags placeholder
            sourceDate: '',
         });

         AjaxFunctions.createEvidenceCard(card).then(data => {
            this.setState({isWaitingOnSubmit: false, submitButtonText: 'Submit'});
            Toastr.options.positionClass = 'toast-bottom-full-width';
            Toastr.success('Created evidence.');
            card.idEvidenceCard = data;
            AjaxFunctions.getUnapprovedCards().then((list) => {
               ReduxStore.store.dispatch(ReduxStore.CardFunctions.setUnapproved(list));
            });
            if (this.state.portfolio.value) {
               AjaxFunctions.addCardToEndOfPortfolio(
                  this.state.portfolio.value,
                  card.idEvidenceCard,
                  SharedConstants.CardType.Evidence
               );
            }
            Utils.updateCurrentUserData();
            this.clearCardInput();
            this.props.onCreate(data);
         });
      });
   }

   getErrorFields(){
      let curFieldErrors = { ...this.state.fieldErrors };
      if(this.state.evidenceFieldsRequired == true){
         curFieldErrors.citation = (this.state.citation && this.state.citation.trim && this.state.citation.trim().length <= 1) ;
         curFieldErrors.year = (this.state.sourceDate && this.state.sourceDate.length <= 1);
      }
      curFieldErrors.summary = this.state.enteredText.length > 200 || this.state.enteredText.length < 1;

      let errorArray = [curFieldErrors.summary];
      if (this.state.evidenceFieldsRequired) {
         errorArray.push(curFieldErrors.citation)
      }

      this.setState({ fieldErrors: curFieldErrors });
      return errorArray.some(error => error === true);
   }

   onFieldChange(stateKey, stateValue) {
      if (stateKey == 'citation') {
         const doiString = 'https://doi.org/';
         let tmp = stateValue.split(doiString).join('');
         [...tmp.matchAll(/10.\d{4,9}\/[-._;()\/:A-Z0-9]+/gi)].forEach((match, i) => {
            const idx = match.index + doiString.length * i;
            tmp = tmp.slice(0, idx) + doiString + tmp.slice(idx);
         });
         stateValue = tmp;
      }

      this.setState({ [stateKey]: stateValue }, () => {
         let toSaveState = {...this.state, 'tour': null};
         LocalStorage.setItem('evidenceCreationState', JSON.stringify(toSaveState));
      });
   }

   render() {
      let headerText = 'Create New Evidence ' + String.fromCharCode(181) + 'Pub';
      if(this.state.id) headerText = 'Update Evidence ' + String.fromCharCode(181) + 'Pub';
      if(this.props.headerText)
         headerText = this.props.headerText;

      return(
         <div>
            <fieldset>
               <div>
                  <h1 className='form__header'>{headerText}</h1>
               </div>
               <div>
                  <MultiLineTextField
                     error={this.state.startPressed && this.state.fieldErrors.citation && this.state.evidenceFieldsRequired}
                     idInput='cardCreationEvidenceCitation'
                     data={this.state.citation}
                     onChange= {event => this.onFieldChange('citation', event.target.value)}
                     dataField= ''
                     checkForValidationErrors={false}
                     placeholder='Paste DOI name, or source author(s), title, and publication, and location'
                     maxLength='300'
                     label='DOI, Link, or Citation'
                     helpLink = 'http://www.easybib.com'
                  />
                  <MultiLineTextField
                     error={this.state.startPressed && this.state.fieldErrors.summary}
                     idInput='cardCreationEvidenceSynopsis'
                     data={this.state.enteredText}
                     onChange= {event => this.onFieldChange('enteredText', event.target.value)}
                     dataField= ''
                     checkForValidationErrors={false}
                     placeholder={"Write a summary of a fact from this source, identifying a subject, express a defined action, " +
                     "communicate learnings/results, and include a time factor."}
                     maxLength='200'
                     label='Summary'
                  />
                  {(!this.props.hideAddToIncubator && this.props.portfolioList.length > 0) && <div style={{ marginTop: '1.6em', marginBottom: '0.9em' }}>
                     <Select
                        closeMenuOnSelect
                        options={this.props.portfolioList.sort((a, b) => b.id - a.id).map(p => ({
                           value: p.id,
                           label: p.name,
                        }))}
                        value={this.state.portfolio}
                        onChange={value => this.onFieldChange('portfolio', value)}
                        id='portfolio-text-input'
                        placeholder='Select an incubator or portfolio (optional)'
                        isClearable
                     />
                  </div>}
               </div>
               <div>
                  <Button
                     color='primary'
                     id='btnCreationClear'
                     onClick={() => {
                        this.clearCardInput();
                        this.onFieldChange('','');
                     }}
                  >
                     Clear Form
                  </Button>
                  <Button color='primary'>
                     <a href='https://youtu.be/IBGBn-meW5k' className={'noHoverDecorate'} target={'_blank'}>
                        Video Instructions
                     </a>
                  </Button>
               </div>
            </fieldset>
            <input
               id='btnEvidenceSubmit'
               className={'active'}
               type='submit'
               value={this.state.submitButtonText}
               onClick={() => this.createEvidenceCard()}
            />
         </div>

      )
   }
}

EvidenceCreationBase.propTypes = {
   onCancel: PropTypes.func,
   onCreate: PropTypes.func,
   allTopics: PropTypes.array,
   revisingCard: PropTypes.object,
};

const mapEvidenceCreationStateToProps = (state) => {
   const { PortfolioReducer: { portfolioList } } = state;
   const curDate = new Date();
   let openSponsored = portfolioList.sponsored.filter(x =>
      x.privacyType === SharedConstants.PortfolioType.Sponsored && (new Date(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime) >= curDate) && x.idBracket == null
   );
   let openPrivate = portfolioList.sponsored.filter(x =>
      x.privacyType === SharedConstants.PortfolioType.SponsoredPrivate && (new Date(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime) >= curDate) && x.idBracket == null
   )
   const combined = [...openSponsored, ...openPrivate, ...portfolioList.owned];
   let ids = [];
   return {
      revisingCard: state.EvidenceCardReducer.revisingCard,
      portfolioList: combined.filter(p => {
         if (!ids.includes(p.id)) {
            ids.push(p.id);
            return true;
         } else {
            return false;
         }
      })
   }
};

export const EvidenceCreation = connect(
   mapEvidenceCreationStateToProps,
   () => {}
)(EvidenceCreationBase);

function convertSelectorToTopic(selectorArray){
   let arr = [];
   for(let selection of selectorArray){
      arr.push({id: selection.value, idTopic: selection.value, name: selection.label});
   }
   return arr;
}
